import navIcons from 'components/Navigation/icons'

const {
  cryptoIconUrl,
  influencersIconUrl,
  ecommerceIconUrl,
  ecommerceExtendedIconUrl,
  freelancersIconUrl,
  shortTermRentalsIconUrl,
  serviceProviderIconUrl,
  companyOverviewIconUrl,
  dataScienceIconUrl,
  nexusIconUrl,
  fatcaIconUrl,
  offshoreIconUrl,
} = navIcons

export const verticalIconMap: Record<string, string> = {
  crypto: cryptoIconUrl,
  nft: cryptoIconUrl,
  ethereum: cryptoIconUrl,
  wallet: cryptoIconUrl,
  smartcontract: cryptoIconUrl,

  influencers: influencersIconUrl,
  onlyfans: influencersIconUrl,

  ecommerce: ecommerceIconUrl,
  shopify: ecommerceIconUrl,

  'ecommerce-extended': ecommerceExtendedIconUrl,
  ecommerce_extended: ecommerceExtendedIconUrl,
  ecommerce_sales_tax: ecommerceExtendedIconUrl,

  freelancers: freelancersIconUrl,
  gig_economy: freelancersIconUrl,
  fiverr: freelancersIconUrl,
  upwork: freelancersIconUrl,
  midrag: freelancersIconUrl,

  str: shortTermRentalsIconUrl,
  airbnb: shortTermRentalsIconUrl,
  'short-term-rentals': shortTermRentalsIconUrl,
  short_term_rentals: shortTermRentalsIconUrl,

  SERVICE_PROVIDER: serviceProviderIconUrl,
  'service-providers': serviceProviderIconUrl,
  service_providers: serviceProviderIconUrl,
  service_provider: serviceProviderIconUrl,

  'company-overview': companyOverviewIconUrl,
  company_overview: companyOverviewIconUrl,

  'data-science': dataScienceIconUrl,
  data_science: dataScienceIconUrl,

  nexus: nexusIconUrl,
  fatca: fatcaIconUrl,
  offshore: offshoreIconUrl,
}

export const getVerticalIcon = (vertical: string): string | undefined => {
  if (!vertical) return undefined
  return (
    verticalIconMap[vertical] ??
    verticalIconMap[vertical.toLowerCase()] ??
    verticalIconMap[vertical.toLowerCase().replace(/[\s-]+/g, '_')]
  )
}
